import { jsx as o } from "react/jsx-runtime";
import { useTheme as f, useMediaQuery as p, Stack as s, Drawer as h, Box as g } from "@mui/material";
import { forwardRef as C, useState as k } from "react";
import { CookiesConsentMain as b } from "./index238.mjs";
import { CookiesConsentManage as v } from "./index239.mjs";
import { TEST_IDS as w } from "./testIds.mjs";
const S = ({ children: i, isPreview: e }) => /* @__PURE__ */ o(
  h,
  {
    open: !0,
    anchor: "bottom",
    disablePortal: e,
    disableScrollLock: e,
    children: i
  }
), x = ({ children: i }) => /* @__PURE__ */ o(g, { zIndex: (e) => e.zIndex.modal, position: "fixed", bottom: 0, children: i }), D = C(
  function(e, d) {
    const { isPreview: l, locale: n, onSave: a } = e, [c, u] = k(!1), m = f(), t = p(
      m.breakpoints.up("sm")
    );
    return /* @__PURE__ */ o(t ? x : S, { isPreview: !!l, children: /* @__PURE__ */ o(
      s,
      {
        style: e.style,
        ref: d,
        "data-testid": e["data-testid"] ?? w.cookiesConsent,
        maxHeight: t ? "100vh" : "85vh",
        sx: { outline: "none" },
        padding: t ? 2 : 0,
        children: /* @__PURE__ */ o(
          s,
          {
            bgcolor: (r) => r.palette.background.level3,
            borderRadius: 4,
            borderColor: (r) => r.palette.divider,
            sx: (r) => ({
              overflowY: "auto",
              overflowX: "hidden",
              borderWidth: 1,
              borderStyle: "solid",
              borderBottomLeftRadius: t ? r.shape.borderRadius * 4 : 0,
              borderBottomRightRadius: t ? r.shape.borderRadius * 4 : 0,
              width: t ? 500 : void 0
            }),
            children: c ? /* @__PURE__ */ o(v, { locale: n, onSave: a }) : /* @__PURE__ */ o(
              b,
              {
                locale: n,
                onManageCookiesClick: () => u(!0),
                onRejectAllClick: () => a({
                  essential: !0,
                  performance: !1,
                  functionality: !1,
                  targetingAdvertising: !1,
                  socialMedia: !1
                }),
                onAcceptAllClick: () => a({
                  essential: !0,
                  performance: !0,
                  functionality: !0,
                  targetingAdvertising: !0,
                  socialMedia: !0
                })
              }
            )
          }
        )
      }
    ) });
  }
);
export {
  D as CookiesConsent
};
//# sourceMappingURL=index135.mjs.map
